import '../styles/AchievementsModal.css';
import { soundManager } from '../utils/sounds';
import { ACHIEVEMENT_DEFS, loadUnlocked } from '../utils/achievements';

function AchievementsModal({ onClose }) {
  const unlocked = new Set(loadUnlocked());
  const unlockedCount = unlocked.size;

  return (
    <div className="achievements-overlay" onClick={onClose}>
      <div className="achievements-modal" onClick={(e) => e.stopPropagation()}>
        <button className="achievements-close" onClick={() => { soundManager.playClick(); onClose(); }}>×</button>

        <div className="achievements-header">
          <span className="achievements-trophy">🏆</span>
          <div>
            <h2 className="achievements-title">Achievements</h2>
            <p className="achievements-count">{unlockedCount} / {ACHIEVEMENT_DEFS.length} unlocked</p>
          </div>
        </div>

        <div className="achievements-progress-bar-wrap">
          <div
            className="achievements-progress-bar-fill"
            style={{ width: `${(unlockedCount / ACHIEVEMENT_DEFS.length) * 100}%` }}
          />
        </div>

        <ul className="achievements-list">
          {ACHIEVEMENT_DEFS.map((def) => {
            const isUnlocked = unlocked.has(def.id);
            return (
              <li key={def.id} className={`achievement-row ${isUnlocked ? 'unlocked' : 'locked'}`}>
                <span className="achievement-icon">{isUnlocked ? def.icon : '🔒'}</span>
                <div className="achievement-text">
                  <span className="achievement-name">{def.title}</span>
                  <span className="achievement-desc">{isUnlocked ? def.desc : '???'}</span>
                </div>
                {isUnlocked && <span className="achievement-badge">✓</span>}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default AchievementsModal;
